import React, { useState } from 'react'

const SkeletonImage = ({ src, alt, className = '' }) => {
  const [isLoading, setIsLoading] = useState(true)

  //   useEffect(() => {
  //     // Bootstrap CDN'i dinamik olarak ekle
  //     const bootstrapCSS = document.createElement('link')
  //     bootstrapCSS.href = 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/css/bootstrap.min.css'
  //     bootstrapCSS.rel = 'stylesheet'
  //     document.head.appendChild(bootstrapCSS)

  //     // Component unmount olduğunda CDN'i kaldır
  //     return () => {
  //       document.head.removeChild(bootstrapCSS)
  //     }
  //   }, [])

  const skeletonStyles = {
    animation: 'skeleton-loading 1s linear infinite alternate',
  }

  const wrapperStyles = {
    position: 'relative',
    width: '90%',
    aspectRatio: '16/9',
    display: 'flex',
    justifyContent: 'center',
  }

  return (
    <>
      <style>
        {`
          @keyframes skeleton-loading {
            0% {
              background-color: #c2cfd6;
            }
            100% {
              background-color: #f0f3f5;
            }
          }
        `}
      </style>

      <div style={wrapperStyles}>
        {isLoading && <div className='rounded-3 position-absolute top-0 start-0 w-100 h-100' style={skeletonStyles} />}

        <img src={src} alt={alt} className={`img-fluid rounded-3 ${className} ${isLoading ? 'd-none' : ''}`} onLoad={() => setIsLoading(false)} />
      </div>
    </>
  )
}

export default SkeletonImage
